 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","airdrop":"airdrop","alcohol":"alcohol","allcards":"allcards","base":"base","buildings":"buildings","callback":"callback","callback2":"callback2","cardsmarket":"cardsmarket","contracts":"contracts","crueltyboard":"crueltyboard","defense":"defense","drugs":"drugs","earlyaccess":"earlyaccess","fightboard":"fightboard","gang":"gang","gang-buildings":"gang-buildings","gang-create":"gang-create","gang-deposits":"gang-deposits","gang-diplomacy":"gang-diplomacy","gang-fights":"gang-fights","gang-settings":"gang-settings","gangjobs":"gangjobs","gangs":"gangs","getstarted":"getstarted","guides":"guides","hall-of-fame":"hall-of-fame","heistboard":"heistboard","help":"help","history":"history","home":"home","incoming":"incoming","invite":"invite","jobboard":"jobboard","jobs":"jobs","leaderboards":"leaderboards","lotteryboard":"lotteryboard","map":"map","market":"market","missions":"missions","mycollection":"mycollection","newcontract":"newcontract","news":"news","occupy":"occupy","outgoing":"outgoing","overview":"overview","privacy":"privacy","referral":"referral","resources":"resources","rewards":"rewards","settings":"settings","shop":"shop","station":"station","steemaccount":"steemaccount","targets":"targets","territory":"territory","tokens":"tokens","training":"training","transport":"transport","tutorial":"tutorial","units":"units","unitsbunker":"unitsbunker","unitshelp":"unitshelp","unitssettings":"unitssettings","userhistory":"userhistory","weapons":"weapons","withdraw":"withdraw"}[chunkId]||chunkId) + "." + {"about":"967d5641","airdrop":"dcb0ecb3","alcohol":"e65cd321","allcards":"fd764705","base":"f0b3ea2b","buildings":"b190454f","callback":"c8d63441","callback2":"d3256da6","cardsmarket":"30635aa4","chunk-2d0e95df":"2db1eade","contracts":"c52bf58e","crueltyboard":"fbdcead5","defense":"16c458cb","drugs":"429095cc","earlyaccess":"d87ed755","fightboard":"83f70a9b","gang":"df02ad92","gang-buildings":"4006bfac","gang-create":"5d030100","gang-deposits":"bcbb3687","gang-diplomacy":"0f771b0e","gang-fights":"c0cbe9b5","gang-settings":"f64ab9ff","gangjobs":"3cafce02","gangs":"7277812a","getstarted":"a6e8b892","guides":"59a67329","hall-of-fame":"e8104270","heistboard":"3d704dc8","help":"399728b0","history":"fc84b65d","home":"a6a26d43","incoming":"6a4ba556","invite":"8d2cee3e","jobboard":"01a5afa1","jobs":"726fdd9f","leaderboards":"7074337c","lotteryboard":"4adc2198","map":"b0101b88","market":"93f8474a","missions":"cfa629cb","mycollection":"0d5f0fac","newcontract":"946cb7b0","news":"32f725bb","occupy":"96e2f25a","outgoing":"168266b8","overview":"965ed0a8","privacy":"5fbb8d11","referral":"0e300c74","resources":"a9996512","rewards":"09a3cef2","settings":"6763c2c4","shop":"8483983b","station":"de50f91e","steemaccount":"48d89665","targets":"253f3f13","territory":"918c660f","tokens":"307b15b1","training":"de425ff8","transport":"e4e107e0","tutorial":"1a56e3e1","units":"bc529a15","unitsbunker":"89594071","unitshelp":"e253afd8","unitssettings":"e5c65915","userhistory":"77431b8b","weapons":"d60d61b6","withdraw":"c8a67b2c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"airdrop":1,"allcards":1,"base":1,"cardsmarket":1,"gang-deposits":1,"gang-diplomacy":1,"gang-fights":1,"getstarted":1,"guides":1,"help":1,"history":1,"home":1,"incoming":1,"leaderboards":1,"market":1,"missions":1,"mycollection":1,"news":1,"occupy":1,"outgoing":1,"overview":1,"referral":1,"resources":1,"station":1,"territory":1,"transport":1,"unitsbunker":1,"unitssettings":1,"userhistory":1,"withdraw":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","airdrop":"airdrop","alcohol":"alcohol","allcards":"allcards","base":"base","buildings":"buildings","callback":"callback","callback2":"callback2","cardsmarket":"cardsmarket","contracts":"contracts","crueltyboard":"crueltyboard","defense":"defense","drugs":"drugs","earlyaccess":"earlyaccess","fightboard":"fightboard","gang":"gang","gang-buildings":"gang-buildings","gang-create":"gang-create","gang-deposits":"gang-deposits","gang-diplomacy":"gang-diplomacy","gang-fights":"gang-fights","gang-settings":"gang-settings","gangjobs":"gangjobs","gangs":"gangs","getstarted":"getstarted","guides":"guides","hall-of-fame":"hall-of-fame","heistboard":"heistboard","help":"help","history":"history","home":"home","incoming":"incoming","invite":"invite","jobboard":"jobboard","jobs":"jobs","leaderboards":"leaderboards","lotteryboard":"lotteryboard","map":"map","market":"market","missions":"missions","mycollection":"mycollection","newcontract":"newcontract","news":"news","occupy":"occupy","outgoing":"outgoing","overview":"overview","privacy":"privacy","referral":"referral","resources":"resources","rewards":"rewards","settings":"settings","shop":"shop","station":"station","steemaccount":"steemaccount","targets":"targets","territory":"territory","tokens":"tokens","training":"training","transport":"transport","tutorial":"tutorial","units":"units","unitsbunker":"unitsbunker","unitshelp":"unitshelp","unitssettings":"unitssettings","userhistory":"userhistory","weapons":"weapons","withdraw":"withdraw"}[chunkId]||chunkId) + "." + {"about":"9f5a4ffa","airdrop":"2c46122e","alcohol":"31d6cfe0","allcards":"55aca02a","base":"c4b127d1","buildings":"31d6cfe0","callback":"31d6cfe0","callback2":"31d6cfe0","cardsmarket":"2374d4c5","chunk-2d0e95df":"31d6cfe0","contracts":"31d6cfe0","crueltyboard":"31d6cfe0","defense":"31d6cfe0","drugs":"31d6cfe0","earlyaccess":"31d6cfe0","fightboard":"31d6cfe0","gang":"31d6cfe0","gang-buildings":"31d6cfe0","gang-create":"31d6cfe0","gang-deposits":"f224b383","gang-diplomacy":"1054ba3c","gang-fights":"d04e28b6","gang-settings":"31d6cfe0","gangjobs":"31d6cfe0","gangs":"31d6cfe0","getstarted":"8f252cf4","guides":"292cc008","hall-of-fame":"31d6cfe0","heistboard":"31d6cfe0","help":"4319c26b","history":"27f7dfd1","home":"ff66ca34","incoming":"d04e28b6","invite":"31d6cfe0","jobboard":"31d6cfe0","jobs":"31d6cfe0","leaderboards":"d04e28b6","lotteryboard":"31d6cfe0","map":"31d6cfe0","market":"927758fd","missions":"94bfe358","mycollection":"ed6f1ae9","newcontract":"31d6cfe0","news":"3d3cc05f","occupy":"744f5e9f","outgoing":"d04e28b6","overview":"d76657d7","privacy":"31d6cfe0","referral":"446871a8","resources":"10cd8537","rewards":"31d6cfe0","settings":"31d6cfe0","shop":"31d6cfe0","station":"d04e28b6","steemaccount":"31d6cfe0","targets":"31d6cfe0","territory":"7fb6622b","tokens":"31d6cfe0","training":"31d6cfe0","transport":"d04e28b6","tutorial":"31d6cfe0","units":"31d6cfe0","unitsbunker":"1cd1bc08","unitshelp":"31d6cfe0","unitssettings":"1b4c11a2","userhistory":"6d34b336","weapons":"31d6cfe0","withdraw":"0e4ef899"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
